module.exports = __webpack_public_path__ + "img/bg-video.6715b213.png";